import { QpStorage } from "./storage"

// export class StorageFactory {
//   static getStorage(type: "local" | "cookie", appId: string): QpStorage {
//     return new QpStorage(type, appId);
//   }

//   static getLocalStorage(appId: string): QpStorage {
//     return new QpStorage("local", appId);
//   }

//   static getCookieStorage(appId: string): QpStorage {
//     return new QpStorage("cookie", appId);
//   }
// }

export function getStorage(type: "local" | "cookie", appId: string): QpStorage {
  return new QpStorage(type, appId);
}

export function getLocalStorage(appId: string): QpStorage {
  return new QpStorage("local", appId);
}

export function getFrameLocalStorage(appId: string, frameWindow: Window): QpStorage {
  return new QpStorage("local", appId, frameWindow);
}


export function getCookieStorage(appId: string): QpStorage {
  return new QpStorage("cookie", appId);
}
